module.exports = __webpack_public_path__ + "static/media/navidad12.078f394a.webp";